import React, { createContext, useState, useEffect } from 'react';
import { getAllProducts } from '../repository/ProductsDAO';
import { useUserContext } from '../context/user_context/UserContext';

// Create a context for products management
export const ProductsContext = createContext({
    products: [],
    loading: false,
    error: null,
    refreshProducts: () => {}
});

/**
 * Products Context Provider Component
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components
 */
export const ProductsProvider = ({ children }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { firebaseUser } = useUserContext();

    const fetchProducts = async () => {
        if (!firebaseUser?.organization) return;
        
        setLoading(true);
        setError(null);
        
        try {
            const fetchedProducts = await getAllProducts(firebaseUser.organization);
            setProducts(fetchedProducts);
        } catch (error) {
            console.error('Error fetching products:', error);
            setError('Failed to load products');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, [firebaseUser]);

    const value = {
        products,
        loading,
        error,
        refreshProducts: fetchProducts
    };

    return (
        <ProductsContext.Provider value={value}>
            {children}
        </ProductsContext.Provider>
    );
};

export default ProductsContext; 